import React, { useState } from "react";
import { IconButton } from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
import CustomDialog from "../../../../../components/Dialog/DiaComp";
import { TextSyndrome } from "./TextSyndrome";
import { SourcesSyndrome } from "./SourcesSyndrome";

export default function DiaTextSyndrome() {

    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};
  
    return (
      <div>

        <IconButton onClick={handleOpen} size="small" >
            <InfoIcon sx={{fontSize: '160%', color: 'background.iconlight', '&:hover': { color: 'primary.light'}, }}/>
        </IconButton>   
      
        <CustomDialog open={open} onClose={handleClose}

          title="METABOLIC SYNDROME"

          content={ <TextSyndrome />}
          
          sources={ <SourcesSyndrome /> }
        />
      </div>
    );
  }